import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InfoRow from "../common/InfoRow";
import { ExpenseCategoryResponseDto } from "../../shared/dtos/expenseCategory/ExpenseCategoryResponseDto";

interface ExpenseCategoryCardProps {
  category: ExpenseCategoryResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const ExpenseCategoryCard: React.FC<ExpenseCategoryCardProps> = ({
  category,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} noWrap>
              {category.name}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", display: "block" }}
              noWrap
            >
              ID: {category.id.split("-")[0]}...
            </Typography>
          </Box>
          <Stack sx={{ flexDirection: "row" }}>
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={
              <AccountBalanceWalletIcon fontSize="small" color="secondary" />
            }
            label="Linked Account"
            value={category.accountName || "Unlinked"}
          />
          <InfoRow
            icon={<AssignmentIcon fontSize="small" color="action" />}
            label="Description"
            value={category.description || "No description provided."}
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default ExpenseCategoryCard;
